import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import GridContainer from "components/Grid/GridContainer.js";

import OverallReports from "./components/OverallReports.js";
import SalesGraph from "./components/SalesGraph.js";
import StoreReportProducts from "./components/StoreReportProducts.js";
import EarningReports from "./components/EarningReports.js";


import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";

import axios from "axios";
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { handleErrors } from "../../common.js";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";

import '../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';

function Dashboard() {

  const navigate    = useNavigate();
  const { t }       = useTranslation();
  const baseUrl     = Config.baseUrl;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading] = useState(false);
  const [isProductsLoading, setIsProductsLoading] = useState(false);
  const [isEarningsLoading, setIsEarningsLoading] = useState(false);
  const [productsObjectToday, setProductsObjectToday] = useState({});
  const [productsObjectWeek, setProductsObjectWeek] = useState({});
  const [productsObjectMonth, setProductsObjectMonth] = useState({});
  const [productsObjectYear, setProductsObjectYear] = useState({});
  const [productsObjectAllTime, setProductsObjectAllTime] = useState({});

  const [earningsObjectToday, setEarningsObjectToday] = useState({});
  const [earningsObjectWeek, setEarningsObjectWeek] = useState({});
  const [earningsObjectMonth, setEarningsObjectMonth] = useState({});
  const [earningsObjectYear, setEarningsObjectYear] = useState({});
  const [earningsObjectAllTime, setEarningsObjectAllTime] = useState({});  
  const [graphData, setGraphData] = useState({});
  const [overallReportObject, setOverallReportObject] = useState({});

  useEffect(() => {
    loadDashboardContents("today", "all-section");
  }, []);

  const handleTimeperiodClick = (timePeriod, dashboardSection) => {

    loadDashboardContents(timePeriod, dashboardSection);

  };


  const loadDashboardContents = (timePeriod, dashboardSection) => {

    if(dashboardSection === "products")
    {
        if(timePeriod === "today" && Object.keys(productsObjectToday).length > 0)
        return;

        if(timePeriod === "week" && Object.keys(productsObjectWeek).length > 0)
        return;

        if(timePeriod === "month" && Object.keys(productsObjectMonth).length > 0)
        return;

        if(timePeriod === "year" && Object.keys(productsObjectYear).length > 0)
        return;

        if(timePeriod === "all-time" && Object.keys(productsObjectAllTime).length > 0)
        return;
    }
    
    if(dashboardSection === "earnings")
    {
        if(timePeriod === "today" && Object.keys(earningsObjectToday).length > 0)
        return;

        if(timePeriod === "week" && Object.keys(earningsObjectWeek).length > 0)
        return;

        if(timePeriod === "month" && Object.keys(earningsObjectMonth).length > 0)
        return;

        if(timePeriod === "year" && Object.keys(earningsObjectYear).length > 0)
        return;

        if(timePeriod === "all-time" && Object.keys(earningsObjectAllTime).length > 0)
        return;
    }

    if(dashboardSection === "all-section")
    setIsLoading(true);

    if(dashboardSection === "products")
    setIsProductsLoading(true);

    if(dashboardSection === "earnings")
    setIsEarningsLoading(true);
    
    axios({      
          url     : baseUrl+"/dashboard/widgets/"+timePeriod+"/"+dashboardSection,
          method  : "GET",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            if(dashboardSection === "all-section")
            setIsLoading(false);

            if(dashboardSection === "products")
            setIsProductsLoading(false);
                
            if(dashboardSection === "earnings")
            setIsEarningsLoading(false);            

            const responseData           = response.data;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {               
                if(responseData && responseData.data)
                { 
                  if(
                    responseData.data && 
                    responseData.data.overallReportObject
                  )
                  setOverallReportObject(responseData.data.overallReportObject);

                  if(
                    responseData.data && 
                    responseData.data.graphObject && 
                    responseData.data.graphObject.graphData
                  )
                  setGraphData(responseData.data.graphObject.graphData);   

                  if(
                    responseData.data && 
                    responseData.data.productsObject
                  )
                  {
                    if(timePeriod === "today")
                    setProductsObjectToday(responseData.data.productsObject);
            
                    if(timePeriod === "week")
                    setProductsObjectWeek(responseData.data.productsObject);
            
                    if(timePeriod === "month")
                    setProductsObjectMonth(responseData.data.productsObject);
            
                    if(timePeriod === "year")
                    setProductsObjectYear(responseData.data.productsObject);
            
                    if(timePeriod === "all-time")
                    setProductsObjectAllTime(responseData.data.productsObject);                   
                  }                  

                  if(
                    responseData.data && 
                    responseData.data.earningsObject
                  )
                  {
                    if(timePeriod === "today")
                    setEarningsObjectToday(responseData.data.earningsObject);
            
                    if(timePeriod === "week")
                    setEarningsObjectWeek(responseData.data.earningsObject);
            
                    if(timePeriod === "month")
                    setEarningsObjectMonth(responseData.data.earningsObject);
            
                    if(timePeriod === "year")
                    setEarningsObjectYear(responseData.data.earningsObject);
            
                    if(timePeriod === "all-time")
                    setEarningsObjectAllTime(responseData.data.earningsObject);    
                  }             
                }
            }  
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }        
        }).catch(function (error) {

          if(dashboardSection === "all-section")
          setIsLoading(false);
          
          handleErrors(error, t, navigate);
        });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        
        {isLoading ?       
              <MDBox py={3} sx={{ textAlign: "center" }}>   
                <CircularProgress size={30} style={{color: '#1a90ff', margin: '0px auto'}}/>
              </MDBox>
        : <></>}
        
        {Object.keys(overallReportObject).length > 0 ?
          <OverallReports overallReportObject = {overallReportObject} />       
        : <></>}

        {Object.keys(graphData).length > 0 ?
          <SalesGraph graphData = {graphData} />       
        : <></>}

        <GridContainer>

          <StoreReportProducts 
              isProductsLoading     = {isProductsLoading}
              productsObjectToday   = {productsObjectToday} 
              productsObjectWeek    = {productsObjectWeek} 
              productsObjectMonth   = {productsObjectMonth} 
              productsObjectYear    = {productsObjectYear} 
              productsObjectAllTime = {productsObjectAllTime} 
              tabOnClick            = {handleTimeperiodClick}
          /> 
          
          <EarningReports 
              isEarningsLoading     = {isEarningsLoading}
              earningsObjectToday   = {earningsObjectToday} 
              earningsObjectWeek    = {earningsObjectWeek} 
              earningsObjectMonth   = {earningsObjectMonth} 
              earningsObjectYear    = {earningsObjectYear} 
              earningsObjectAllTime = {earningsObjectAllTime} 
              tabOnClick            = {handleTimeperiodClick}
          /> 
                      
        </GridContainer>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;